<template>
  <section-container>
    <div class="w-full flex justify-center items-center flex-wrap p-2">
      <div class="w-full lg:w-1/3 flex flex-wrap flex-col">
        <h2 class="text-4xl font-bold mb-2">Clientes</h2>
        <h3 class="text-xl mb-2 text-gray-600">
          Todos os clientes cadastrados
        </h3>
        <div class="my-5">
          <router-link
            class="px-6 py-4 text-md rounded font-bold text-white bg-indigo-600 hover:bg-indigo-700 border-indigo-500"
            :to="{ name: 'customers.create' }"
          >
            <font-awesome-icon icon="plus" class="mr-2" />
            Adicionar novo cliente
          </router-link>
        </div>
      </div>

      <div class="w-full lg:w-2/3 flex justify-center items-center px-4">
        <img
          src="@/assets/img/orders.png"
          alt=""
          width="650px"
          class="h-auto overflow-hidden"
        />
      </div>
    </div>
    <content-e>
      <div class="w-full rounded-lg bg-white shadow-2l">
        <div class="overflow-auto sm:overflow-x-auto md:overflow-x-auto p-5">
          <table class="text-left w-full table-responsive">
            <thead>
              <tr>
                <th
                  class="w-1/4 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Nome
                </th>
                <th
                  class="w-1/4 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Telefone
                </th>
                <th
                  class="w-1/4 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  E-mail
                </th>
                <th
                  class="w-1/4 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Endereço
                </th>
                <th
                  class="w-1/4 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="customer in customers.data"
                :key="`customer-${customer.id}`"
              >
                <td
                  class="border-dashed border-t border-gray-200 px-3 py-4 text-sm"
                >
                  {{ customer.name }}
                </td>
                <td
                  class="border-dashed border-t border-gray-200 px-3 py-4 text-sm"
                >
                  {{ customer.phone }}
                </td>
                <td
                  class="border-dashed border-t border-gray-200 px-3 py-4 text-sm"
                >
                  {{ customer.email }}
                </td>
                <td
                  class="border-dashed border-t border-gray-200 px-3 py-4 text-sm"
                >
                  {{ customer.address.city + '/' + customer.address.uf }}
                </td>
                <td
                  class="border-dashed border-t border-gray-200 px-3 py-4 text-sm"
                >
                  <router-link
                    :to="{
                      name: 'customers.update',
                      params: { id: customer.id }
                    }"
                    class="mr-1 relative inline-block px-2 py-1 font-bold text-blue-500 leading-tight bg-blue-100 rounded-full"
                  >
                    <font-awesome-icon icon="eye" />
                    <ui-tooltip position="bottom" animation="fade"
                      >Visualizar</ui-tooltip
                    >
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="w-full mt-5">
        <pagination
          :pagination="customers"
          @paginate="doCustomers"
          :offset="3"
        ></pagination>
      </div>
    </content-e>
  </section-container>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  name: 'customer.index',
  components: {
    Pagination
  },
  data() {
    return {
      customers: {}
    }
  },
  methods: {
    async doCustomers() {
      const customers = await this.$store.dispatch('store/LOAD_CUSTOMERS')
      this.customers = customers.data
    }
  },
  mounted() {
    this.doCustomers()
  }
}
</script>

<style>
</style>
